import { FileTypeIconMap, permissionTypes } from '@/constants'
import config from '@/config'
import Store from '@/store'

export function checkEnv () {
  if (process.env.NODE_ENV === 'test') {
    return null
  } else {
    return false
  }
}

export function decodeJWT (token) {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))

  return JSON.parse(jsonPayload)
}

export function getCollectionEntryTypeIcon (collectionEntry) {
  if (!checkEnv()) {
    let icon = null
    switch (collectionEntry.object.content_type) {
      case 'LEGACY_ENGINE': {
        return require('@/assets/images/fileTypeIcons/classe.svg')
      }
      case 'FILE': {
        icon = collectionEntry.data.metadata.fileType
        break
      }
      case 'VIDEO_YOUTUBE': {
        return require('@/assets/images/youtube_file_icon.svg')
      }
      case 'VIDEO_UPLOAD': {
        return require('@/assets/images/video_file_upload.svg')
      }
      case 'AUDIO': {
        return require('@/assets/images/sound-blue.svg')
      }
      case 'EXTERNAL': {
        if (collectionEntry.data.metadata.serviceUrl) {
          const serviceUrl = collectionEntry.data.metadata.serviceUrl
          return serviceUrl + '/favicon.ico'
        } else {
          return require('@/assets/images/fileTypeIcons/photo.svg')
        }
      }
    }
    return getFileTypeIcon(icon)
  }
}

export function getFileTypeIcon (icon) {
  if (!checkEnv()) {
    for (const key in FileTypeIconMap) {
      for (const subKey in FileTypeIconMap[key]) {
        if (FileTypeIconMap[key][subKey] === icon) {
          icon = key
          break
        }
      }
    }
    try {
      return require('@/assets/images/fileTypeIcons/' + icon + '.svg')
    } catch (err) {
      return require('@/assets/images/fileTypeIcons/file.svg')
    }
  }
}

export function getClassificationIcon (classificationKey) {
  if (!checkEnv()) {
    try {
      return require('@/assets/images/classificationIcons/' + classificationKey + '.svg')
    } catch (err) {
      return require('@/assets/images/classificationIcons/נושא.svg')
    }
  }
}

export function editUrl (url) {
  const correctUrl = url.split('.digitaloceanspaces')
  return correctUrl[0] + '.digitaloceanspaces' + correctUrl[2]
}

export function htmlParser (str) {
  const parser = new DOMParser()
  const doc = parser.parseFromString(str, 'text/html')
  const text = doc.body.innerText
  return text
}

export function getClasseUnitUrl (unitId, lang = null) {
  if (!lang) {
    lang = Store.state.base.lang.localName
  }
  // If lang is still null, set `en` as default.
  if (!lang) {
    lang = 'en'
  }
  return config.classeUrl + 'teacher/#!/' + lang + '/session/' + unitId + '/lessons?hideLogout=true'
}

export function shouldRotate () {
  let entry = null
  entry = this.collectionEntry
  if (!entry) {
    entry = this.selectedEntry
  }
  return ['VIDEO_UPLOAD', 'AUDIO'].indexOf(entry.object.content_type) > -1
}

export function getUploadType (selectedEntry) {
  switch (selectedEntry.object.content_type) {
    case 'LEGACY_ENGINE':
      return 'classe'
    case 'FILE':
      return 'file'
    case 'VIDEO_YOUTUBE':
      return 'youtube'
    case 'VIDEO_UPLOAD':
      return 'video'
    case 'EXTERNAL':
      return 'url'
    case 'AUDIO': {
      if (selectedEntry.data.metadata.isEmbeddedAudio) {
        return 'embedded-audio'
      } else {
        return 'audio'
      }
    }
  }
  return 'file'
}
export function isUrlValid (url) {
  try {
    return fetch(new URL(url), { mode: 'no-cors' }).then(() => {
      return true
    }).catch(err => {
      console.log(err)
      return false
    })
  } catch {
    return false
  }
}

export function getPermissionTypes () {
  return Object.values(permissionTypes).map(permission => permission.charAt(0).toUpperCase() + permission.slice(1))
}

export function getIconOfUrl (url) {
  if (url.includes('fra1.digitaloceanspaces.com')) {
    return getFileTypeIcon(url.substring(url.lastIndexOf('.') + 1, url.length))
  } else if (url.includes('youtube')) {
    return require('@/assets/images/youtube_file_icon.svg')
  } else {
    try {
      const urlForIcon = url.slice(0, url.indexOf(url.split('/')[3]) - 1)
      return (urlForIcon + '/favicon.ico')
    } catch (err) {
      return require('@/assets/images/fileTypeIcons/file.svg')
    }
  }
}
